import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/** Mirrors the `md` breakpoint in src/styles/_breakpoints.scss. */
export const MOBILE_MAX_WIDTH = 767;

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private query = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
  private mobile = new BehaviorSubject<boolean>(this.query.matches);

  constructor(private zone: NgZone) {
    const onChange = (event: MediaQueryListEvent) =>
      this.zone.run(() => this.mobile.next(event.matches));

    if (this.query.addEventListener) {
      this.query.addEventListener('change', onChange);
    } else {
      this.query.addListener(onChange);
    }
  }

  get isMobile(): boolean {
    return this.mobile.value;
  }

  get isMobile$(): Observable<boolean> {
    return this.mobile.pipe(distinctUntilChanged());
  }
}
